import { useTranslation } from "react-i18next";

const cyan = "#00f5ff";
const border = "rgba(0,245,255,0.15)";

// Shared Previous/Next pagination control + "Showing X-Y of Z" count line,
// used by every list view backed by a paginated backend endpoint
// ({ data, total, page, limit, totalPages }).
function Pagination({ page, limit, total, totalPages, onPageChange, itemLabel = "items" }) {
  const { t } = useTranslation();
  if (!total) return null;

  const start = total === 0 ? 0 : (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "10px",
        padding: "10px 0",
        fontSize: "11px",
        color: "rgba(0,245,255,0.5)",
        letterSpacing: "1px",
      }}
    >
      <span>
        {t("common.showingRange", { start, end, total, item: itemLabel })}
      </span>
      {totalPages > 1 && (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <button
            onClick={() => onPageChange(page - 1)}
            disabled={page <= 1}
            style={{
              background: "none",
              border: `1px solid ${border}`,
              color: page <= 1 ? "rgba(0,245,255,0.25)" : cyan,
              fontSize: "10px",
              fontWeight: "700",
              letterSpacing: "1px",
              padding: "5px 12px",
              borderRadius: "4px",
              cursor: page <= 1 ? "not-allowed" : "pointer",
            }}
          >
            {t("common.prev")}
          </button>
          <span style={{ color: "rgba(255,255,255,0.5)" }}>
            {t("common.pageOf", { page, totalPages })}
          </span>
          <button
            onClick={() => onPageChange(page + 1)}
            disabled={page >= totalPages}
            style={{
              background: "none",
              border: `1px solid ${border}`,
              color: page >= totalPages ? "rgba(0,245,255,0.25)" : cyan,
              fontSize: "10px",
              fontWeight: "700",
              letterSpacing: "1px",
              padding: "5px 12px",
              borderRadius: "4px",
              cursor: page >= totalPages ? "not-allowed" : "pointer",
            }}
          >
            {t("common.next")}
          </button>
        </div>
      )}
    </div>
  );
}

export default Pagination;
